<template>
  <div>
    <b-row>
      <b-col cols="12">
        <h4>Foto's</h4>
        <hr>
      </b-col>
    </b-row>

    <b-row>
      <b-col lg="12" md="12" sm="12">
        Kies uitgelichte afbeelding
        <v-select :options="images" label="name" v-model="selected" :value="$store.myValue" @input="setSelected" class="mb-3">
          <template v-slot:option="option">
            <img :src="option.responsive.xs" :alt="option.name" class="img-thumbnail">
            {{ option.name }}
          </template>
        </v-select>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="3" md="6" sm="12" v-for="item in images" :key="item.id" class="d-flex align-items-stretch">
        <div class="card rounded-0 w-100 bg-white position-relative">
          <i class="bi bi--circle-fill"></i>

          <span v-if="selected && selected.id === item.id" class="position-absolute float-right">
            <i class="fa fa-check-circle fa-2x text-success " aria-hidden="true"></i>
          </span>
        <img :src="item.responsive.md" class="card-img-top img-responsive w-100" :alt="item.id">
          <b-button @click="openRemoveModal(item)" variant="danger btn-sm"><i class="fa fa-trash"></i> Verwijder</b-button>
        </div>


      </b-col>
    </b-row>
    <b-row class="mt-5">
      <b-col cols="12">
        <h4>Overige bestanden</h4>
        <hr>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <ul class="list-group mb-5" >
          <li v-for="item in files" :key="item.id" class="list-group-item d-flex">

             <a :href="item.url" class="flex-grow-1" target="_blank">{{ item.name }}  </a>
            <b-button class="btn-sm btn-danger float-right hoverable" @click="openRemoveModal(item)">
              <i class="fa fa-trash"></i> Verwijder
            </b-button>

          </li>
        </ul>
      </b-col>
    </b-row>
    <b-modal ref="remove-file" id="remove-file" title="Bestand verwijderen">
      <p class="my-4">Weet je zeker dat je <strong>"{{deletable.name}}"</strong> wilt verwijderen? Deze actie is
        onomkeerbaar.</p>
      <template v-slot:modal-footer>
        <b-button @click="hideModal">Nee</b-button>
        <b-button variant="danger" @click="deleteFile">Ja, verwijder</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>

import {deleteItem, updateData} from "@/api";

export default {
  props: ['files', 'images', 'featured_image'],
  data() {
    return {
      deletable: {},
      selected: this.featured_image ? this.featured_image : null,
    }
  },
  watch: {
    featured_image: function(val) {
      this.selected = val
    }
  },
  // computed: {
  //   model: {
  //     get() { return this.value },
  //     set(v) { this.$emit("input", v) }
  //   },
  //
  //   documents: function(){
  //     return this.model.map(document => {
  //       if(this.documentTypes.hasOwnProperty(document.type)) {
  //         document.type = this.documentTypes[document.type];
  //       }
  //
  //       return document;
  //     })
  //   },
  // },
  methods: {
    async setSelected(value) {
        await updateData('project-introductions/' + this.$route.params.id + '/media/' + value.id , value).then(response => response.data);
      this.selected = value
    },


    deleteFile() {
      deleteItem(`project-introductions/${this.$route.params.id}/media/${this.deletable.id}`).then(({data}) => {
        this.$refs['remove-file'].hide();
        this.model = data.data;
        this.$emit('deletedFile', data.deletedId)

      });
    },
    openRemoveModal(document) {
      this.deletable = document;

      this.$refs['remove-file'].show();
    },
    hideModal() {
      this.$refs['remove-file'].hide();
    }
  }
}
</script>

<style>
.card-img-top {
  max-height: 150px;
  min-height: 150px;
  object-fit: cover;
}
</style>
